var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "column" }, [
    _c("div", { staticClass: "col" }, [
      _c("span", { staticClass: "text-overline" }, [
        _vm._v(_vm._s(_vm.$t("searchType")))
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col" },
      [
        _c(
          "q-btn-group",
          [
            _c(
              "q-btn",
              {
                class: _vm.viewButtonClass(_vm.blockSearch),
                attrs: {
                  icon:
                    "img:\\typo3conf\\ext\\ig_warehouse\\Resources\\Public\\Icons\\logs-24.svg"
                },
                on: {
                  click: function($event) {
                    return _vm.$emit("updatedSearchType", _vm.blockSearch)
                  }
                }
              },
              [
                _c("q-tooltip", [
                  _vm._v(_vm._s(_vm.$t("searchTypes.blockSearch")))
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "q-btn",
              {
                class: _vm.viewButtonClass(_vm.palletSearch),
                attrs: {
                  icon:
                    "img:\\typo3conf\\ext\\ig_warehouse\\Resources\\Public\\Icons\\pallets-24.svg"
                },
                on: {
                  click: function($event) {
                    return _vm.$emit("updatedSearchType", _vm.palletSearch)
                  }
                }
              },
              [
                _c("q-tooltip", [
                  _vm._v(_vm._s(_vm.$t("searchTypes.palletSearch")))
                ])
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }